import { Component, Input } from '@angular/core';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
  selector: 'app-cancellation-policy',
  templateUrl: './cancellation-policy.component.html',
  styleUrls: ['./cancellation-policy.component.scss'],
})
export class CancellationPolicyComponent {
  @Input() buttonColor = 'grey-500';

  @Input() classes = '';

  constructor(private utilityService: UtilityService) {}

  openCancellationPolicy() {
    this.utilityService.openExternalLink('https://mable.com.au/cancellation-policy/');
  }
}
